<app-table-component (onPagination)="onPagination($event)"
                     [props]="tableConfigAndProps"
                     [isViewClick]="false"
                     height="23vh"
                     (selectedItem)="actionButtonOutput($event)"></app-table-component>
